/*
 * @Author: hanchunxuan 1627047609@qq.com
 * @Date: 2023-10-08 09:22:29
 * @LastEditors: hanchunxuan 1627047609@qq.com
 * @LastEditTime: 2023-10-14 10:07:18
 * @FilePath: \1008\zonghoutai-front\src\api\base.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const base = {
     host:'',
     captchaImage:'/api/captchaImage',
     login:'/api/login',
     logout:'/api/logout',
     getInfo:'/api/getInfo',
     userList:'/api/system/user/list',
     getUser:'/api/system/user/',
     addUser:'/api/system/user',
     updateUser:'/api/system/user',
     getSonStation:'/api/system/views/getMainStationStatisticsDate',//获取子站
     getStationList:'/api/system/station',//获取总站列表
     getAllStationPublic:'/api/system/views/getAllStationPublicationsNumber',// get请求，返回值为map类型 根据用户id获取各个总站发布数
     getPublishedPages:'/api/system/views/getNumberOfPublicationsPages',
	 getObtainAccess:'/api/system/views/getObtainAccessToAllTotalStationsBasedOnUserIDs',// get请求，返回值为对象，根据用户id获取所有总站的访问量
     getRetrieve:'/api/system/views/getNumberOfViewsStationByUserId',// get请求，返回值为对象，根据用户id获取所有总站的浏览次数
     getVideoPlay:'/api/system/views/videoPlay',//短视频播放量
     getvideoFans:'/api/system/views/videoFans',//短视频粉丝量
     getvideoRelease:'/api/system/views/videoRelease',//短视频发布量
     worldMapInfos:'/api/system/views/worldMapInfos',//全球子站数据
     getExposureFromUserId:'/api/system/views/getExposureFromUserId',//菜单数据
     getTikTokStationJoinSysUser:'/api/system/tiktokStation/getTikTokStationJoinSysUser',//菜单数据
	 doLogin:'/api/doLogin',
 



     
}


export default base 

